import React from 'react';

type AppProps = {
  value: number;
  testId?: string | null;
};

const Weight: React.FC<AppProps> = ({ value, testId = null }) => {
  return (
    <p className="text-sm font-medium" data-testid={testId}>
      {value ? `${value} lbs` : '-'}
    </p>
  );
};

export default Weight;
